import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import LightBoxPhotoList from '../../components/LightBoxPhotoList';
import { typography } from '../../styles';


const styles = css`
  display: block;
  width: 100%;
  margin: 0;
  padding: 20px 0;
  color: #FFFFFF;
  font-family: ${typography.SansSerif};

  .Schools_body{
    font-weight: 300;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 30px;
    text-align: center;
    @media(min-width: 992px) {
      font-size: 18px;
      line-height: 26px;
    }
  }
  .Schools_sectionTitle{
    display: block;
    width: 100%;
    font-family: ${typography.SansSerif};
    font-weight: 300;
    font-size: 24px;
    letter-spacing: 0;
    @media(min-width: 768px) {
      font-size: 30px;
    }
    @media(min-width: 992px) {
      font-size: 35px;
    }
    @media(min-width: 1200px) {
      font-size: 40px;
    }
  }
  .Btn{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .School_btn{
    padding: 10px;
  }
`;


function Schools({ page }) {
  const content = get(page, 'community_school_info[0]');
  return (
    <div className={styles}>
      <div className="container">
        <h3 className="Schools_sectionTitle GoldText Underdog_center text-center">Schools</h3>
        <div className="Schools_body mb-5" dangerouslySetInnerHTML={SanitizeHtml(content.info)} />
        <LightBoxPhotoList
          show={8}
          photos={content.photos}
        />
        <h3 className="Schools_sectionTitle GoldText Underdog_center text-center">Public Schools</h3>
        <div className="d-flex flex-wrap justify-content-center mb-5">
          {page.public_schools.map(school => (
            <div key={school._id} className="School_btn">
              <a className="" href={school.link} target="_blank" rel="noopener noreferer">{school.school_name}</a>
            </div>
          ))}
        </div>
        <h3 className="Schools_sectionTitle GoldText Underdog_center text-center">Private Schools</h3>
        <div className="d-flex flex-wrap justify-content-center mb-5">
          {page.private_schools.map(school => (
            <div key={school._id} className="School_btn">
              <a className="" href={school.link} target="_blank" rel="noopener noreferer">{school.school_name}</a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
Schools.propTypes = {
  page: PropTypes.object.isRequired,
};
export default(Schools);



// WEBPACK FOOTER //
// ./src/pages/Overview/Schools.js